import { Observable, of } from 'rxjs/index';
import Event from '../../core/Event';
import { ofType, StateObservable } from 'redux-observable';
import State from '../State';
import api from '../../core/api';
import { catchError, map, mergeMap } from 'rxjs/internal/operators';
import { AjaxError, AjaxResponse } from 'rxjs/internal/observable/dom/AjaxObservable';
import RequestFailed from '../../core/events/RequestFailed';
import EstimationPeriodRequested from '../events/EstimationPeriodGetRequested';
import EstimationPeriodReceived from '../events/EstimationPeriodGetSucceed';
import { AjaxBackend } from '../../testHelpers/fakeBackendFactory';

export default (event$: Observable<Event>, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> =>
    event$.pipe(
        ofType(EstimationPeriodRequested.type),
        mergeMap(() =>
            backend.get(`${api()}estimation-periods`).pipe(
                map((ajaxResponse: AjaxResponse) => new EstimationPeriodReceived(ajaxResponse.response)),
                catchError((e: AjaxError) => of(new RequestFailed(e.status)))
            )
        )
    );



// WEBPACK FOOTER //
// ./src/application/admin/epic/estimationPeriodsGet.ts